export default __webpack_public_path__ + "static/basia-e7143e70cd1a964a9b3ddccac526b8e6.jpg";